'use client';

import { fetcher } from '@insta-club/api';
import { LegacyIcon, ModernIcon } from '@insta-club/components/icons';
import { AnalysisSkeleton } from '@insta-club/components/skeleton';
import { Calendar, CalendarResponse, modes, Note, ViewMode } from '@insta-club/models';
import { useViewModeStore } from '@insta-club/state';
import { cn, isSameJalaaliDate } from '@insta-club/utilities';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import ProgramCalendar from './program-calendar';
import ProgramDetails from './program-details';
import ProgramNote from './program-note';

interface Props {
    programID: number;
    viewMode: ViewMode;
}

const ProgramFullCard: React.FC<Props> = ({ programID, viewMode }) => {
    const setViewMode = useViewModeStore((state) => state.setMode);
    const [selected, setSelected] = useState<Calendar>();
    const [notes, setNotes] = useState<Note[]>();

    const { data, isLoading } = useSWR<CalendarResponse>(`/programs/calendar/${programID}`, (url: string) =>
        fetcher(url, 'dashboard')
    );
    const calendar = data?.calendar;
    const dataNotes = data?.notes ?? [];

    useEffect(() => {
        if (!calendar?.length) return;
        const initialDay = calendar.find((d) => isSameJalaaliDate(d.date)) ?? calendar[0];
        setSelected(initialDay);
    }, [calendar]);

    if (isLoading) return <AnalysisSkeleton />;

    return (
        <>
            {calendar && (
                <>
                    <div className='mb-4 flex items-center justify-between'>
                        <h3 className='flex items-center gap-1 text-base font-semibold'>
                            <div className='min-h-4 space-x-1.5 leading-loose'>
                                <span className='font-medium text-gray-500'>شناسه برنامه :</span>
                                <span
                                    className='text-gray-800'
                                    style={{
                                        fontFamily: 'Poppins'
                                    }}
                                >
                                    {calendar[0]?.program_name ?? ''}
                                </span>
                            </div>
                        </h3>
                        <div className='flex overflow-hidden rounded-full bg-gray-200 text-[10px] font-semibold transition-colors'>
                            {modes.map((mode, index) => (
                                <button
                                    key={mode.key}
                                    type='button'
                                    onClick={() => setViewMode(mode.key)}
                                    className={cn(
                                        'flex items-center space-x-2 px-2 py-0.5 transition-colors duration-200 focus:outline-none',
                                        viewMode === mode.key
                                            ? 'bg-gray-700 text-white'
                                            : 'text-gray-700 hover:bg-gray-400/50',
                                        index === 0 ? 'rounded-r-full pr-2.5' : 'rounded-l-full pl-2.5'
                                    )}
                                >
                                    {mode.key === 'legacy' ? <LegacyIcon width={12} /> : <ModernIcon width={12} />}
                                </button>
                            ))}
                        </div>
                    </div>
                    {/* // -ml-5 sm:-ml-6 */}
                    <div className='mb-6'>
                        <ProgramCalendar
                            // viewMode={viewMode}
                            value={selected}
                            onChange={setSelected}
                            calendar={calendar}
                        />
                    </div>
                </>
            )}
            <div className='space-y-6'>
                {dataNotes.length || notes?.length ? <ProgramNote notes={notes ?? []} pinnedNotes={dataNotes} /> : null}
                {/* {calendar ? <ProgramCalendarHead value={selected} onChange={setSelected} calendar={calendar} /> : null} */}

                <div className='relative flex flex-col gap-3'>
                    {/* <div className='shadow-card relative flex flex-col gap-4 rounded-2xl border border-gray-200 bg-white px-6 py-3'> */}
                    {selected ? <ProgramDetails id={programID} calendar={selected} onNotes={setNotes} /> : null}
                </div>
            </div>
        </>
    );
};

export default ProgramFullCard;

